import { gql } from '@apollo/client';

export const READ_NOTIFICATION = gql`
  mutation READ_NOTIFICATION($notificationIds: [Float!]!) {
    flagHasReadNotification(notificationIds: $notificationIds) {
      id
    }
  }
`;
